module.exports = __webpack_public_path__ + "cb7db31395e1a0d99e98b14679b449a1.svg";